import React from 'react';
import {
  NavLink
} from "react-router-dom";
import { withRouter } from "react-router";
import {
  HomeOutlined,
  HomeFilled,
  ContactsOutlined,
  ContactsFilled,
  PhoneFilled
} from '@ant-design/icons';
import './NavBar.css';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Button } from 'antd';

class NavBar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showCallModal: false
    };
  }
  showModal = () => {
    this.setState({
      showCallModal: true
    });
  }
  closeModal = () => {
    this.setState({
      showCallModal: false
    });
  }
  render() {
    const activeRoute = this.props.location.pathname;
    return (
      <div className="navigation">
        <NavLink to="/">
          <div className="navLinkContainer">
            {
              activeRoute !== '/' &&
              <HomeOutlined className="icon" />
            }
            {
              activeRoute === '/' &&
              <HomeFilled className="icon" />
            }
            <span className="navLabel">Home</span>
          </div>
        </NavLink>
        <NavLink to="/profile">
          <div className="navLinkContainer">
            {
              activeRoute !== '/profile' &&
              <ContactsOutlined className="icon" />
            }
            {
              activeRoute === '/profile' &&
              <ContactsFilled className="icon" />
            }
            <span className="navLabel">Profile</span>
          </div>
        </NavLink>
        <PhoneFilled onClick={this.showModal} className="callButton" />
        <div className={cx("callModal", this.state.showCallModal ? 'show' : '' )}>
          <p className="desc">This call will be redirected to Pristyn Care helpline and will be charged ₹250/consultation.</p>
          <a href="tel:7428094073">
            <Button
              type="primary"
              icon={<PhoneFilled />}
              onClick={this.enterIconLoading}
              className="ctaButton callNow"
            >
              Call
            </Button>
          </a>
          <Button type="default" className="noThanks ctaButton" onClick={this.closeModal}>No thanks, i'll call later</Button>
        </div>
      </div>
    );
  }
}

NavBar.propTypes = {
  location: PropTypes.object.isRequired,
};
export default withRouter(NavBar);
